export const TRAILER_FUEL_TYPES = ['АИ', 'ДТ', 'Битум', 'Нефть', 'Газ', 'Масло'];
